import { Header, Segment } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import createWorkDraftData from "astrid-firestore/src/api/works/createWorkDraftData";

import Button from "../../../ui/components/Buttons/Button";
import PlaceholderSegment from "../../../ui/components/PlaceholderSegment/PlaceholderSegment";

import ArticlesDeliveryNeededMessage from "../../../articles/components/ArticlesDeliveryNeededMessage/ArticlesDeliveryNeededMessage";
import WorkMetaDataEdit from "../../../works/components/WorkMetaDataEdit/WorkMetaDataEdit";

import SerieSummary from "../../components/SerieMetaData/SerieMetaData";

import SerieWork from "./components/SerieWork";

export default function SerieOverviewView({ serie, publisher, works, articles, channels }) {
	const { t } = useTranslation();

	const [workDraft, setWorkDraft] = useState(null);

	const nextSerieNumber = Math.max(0, ...works.map((work) => work.serieNumber || 0)) + 1;

	return (
		<>
			<ArticlesDeliveryNeededMessage publisher={publisher} articles={articles} channels={channels} />

			<Header as="h3">{t("metadata", "Metadata")}</Header>

			<SerieSummary serie={serie} publisher={publisher} />

			{works.map((work) => {
				return (
					<SerieWork
						key={work.id}
						work={work}
						articles={articles.filter((article) => article.work?.id === work.id)}
						channels={channels}
						publisher={publisher}
						disableSerie
					/>
				);
			})}

			<Segment basic style={{ paddingLeft: 0, paddingRight: 0 }}>
				<Header as="h3" style={{ margin: 0 }}>
					<Header.Subheader>
						{t("part")} {nextSerieNumber}
					</Header.Subheader>
				</Header>

				<PlaceholderSegment
					onClick={() =>
						setWorkDraft(createWorkDraftData({ serie, publisher, serieNumber: nextSerieNumber }))
					}
				>
					<Button>{t("createWork", "Create work")}</Button>
				</PlaceholderSegment>
			</Segment>

			{workDraft && (
				<WorkMetaDataEdit
					work={workDraft}
					publisher={publisher}
					onSuccess={() => setWorkDraft(null)}
					onClose={() => setWorkDraft(null)}
					disableSerie
				/>
			)}
		</>
	);
}
